import React from 'react';

function ActivitySkeleton({ count = 5 }) {
    return (
        <div className="activity-skeleton">
            {Array.from({ length: count }).map((_, index) => (
                <div className="activity-skeleton__item" key={`activity-skeleton-${index}`}>
                    <div className="activity-skeleton__line activity-skeleton__line--medium mb-2"></div>
                    <div className="activity-skeleton__line activity-skeleton__line--short mb-3"></div>
                    <div className="activity-skeleton__line activity-skeleton__line--long"></div>
                </div>
            ))}
        </div>
    );
}

export default ActivitySkeleton;
